import PropTypes from "prop-types";

import { YourMajors } from "../";
import { Panel } from "../../compose";
import { getTheme } from "../../utils";

function CollegeMajorsCard({
  id,
  open,
  chosenSchool,
  externalToggle,
  callbackToggle,
}) {
  const { award, school, selectedMajors } = chosenSchool;

  const theme = getTheme({
    affordability: award?.postAwardSchoolCosts?.affordability,
  });

  return (
    <Panel
      id={id}
      title="majors"
      initiallyOpened={open}
      externalToggle={externalToggle}
      callbackToggle={callbackToggle}
      className="p-4 mb-2 bg-white shadow-lg"
      titleClassName="
        flex
        flex-1
        flex-row
        capitalize
        font-semibold
      "
      expandableContent={
        <>
          {selectedMajors.length ? (
            <YourMajors
              color={theme.color}
              showActions={false}
              schoolName={school.name}
              majorsSelected={selectedMajors}
            />
          ) : (
            <div className="my-auto text-sm font-bold text-center capitalize">
              No majors selected!
            </div>
          )}
        </>
      }
    />
  );
}

CollegeMajorsCard.propTypes = {
  id: PropTypes.string,
  open: PropTypes.bool,
  externalToggle: PropTypes.bool,
  callbackToggle: PropTypes.func,
  chosenSchool: PropTypes.shape(),
};

export default CollegeMajorsCard;
